import { Bell } from "lucide-react";
import { getUrgencyLabel, getReminderUrgency } from "../../utils/reminderUtils";

const URGENCY_PILL_STYLES = {
  OVERDUE: "bg-red-50 text-red-700",
  DUE_SOON: "bg-amber-50 text-amber-700",
  FRESH: "bg-gray-100 text-gray-600",
};

export function RemindersComponent({ remindersToShow, onClick }) {
  return (
    <div
      className="lg:col-span-2 bg-white rounded-xl border border-gray-200 p-6 shadow-sm w-full"
      onClick={onClick}
      style={{ cursor: "pointer" }}
    >
      <h2 className="text-lg font-semibold text-gray-900 mb-4">
        Expiring soon
      </h2>

      {remindersToShow.length === 0 ? (
        <div className="flex flex-col items-center justify-center py-12 px-4">
          <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mb-4">
            <Bell className="w-8 h-8 text-gray-400" />
          </div>
          <p className="text-sm text-gray-600 text-center">
            Nothing expiring soon.
          </p>
        </div>
      ) : (
        <div
          className="overflow-y-auto space-y-1 w-full"
          style={{ maxHeight: "400px" }}
        >
          {remindersToShow.map((reminder) => (
            <div
              key={reminder.reminderId}
              className="group flex items-center justify-between px-3 py-2 rounded-lg hover:bg-gray-50 transition-colors w-full"
            >
              <span className="text-sm text-gray-900 font-medium truncate">
                {reminder.itemName}
              </span>

              <span
                className={`text-xs font-medium px-2.5 py-1 rounded-full whitespace-nowrap ml-4 ${URGENCY_PILL_STYLES[getReminderUrgency(reminder)]}`}
              >
                {getUrgencyLabel(reminder)}
              </span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
